
import React, { Component } from 'react'
import { withScriptjs, withGoogleMap, GoogleMap, Marker, DirectionsRenderer, InfoWindow } from "react-google-maps"
import privado from '../../img/privado.png';
import taxi from '../../img/taxi.png';
import microbuses from '../../img/bus.png';
import destino from '../../img/placeholder.png';
import cliente from '../../img/mark1.png';
import firebase from 'firebase';
const FaAnchor = require("react-icons/lib/fa/anchor");


const google = window.google;

const Privado = { url: privado, scaledSize: new google.maps.Size(30, 35) };
const Taxi = { url: taxi, scaledSize: new google.maps.Size(30, 35) };
const Microbus = { url: microbuses, scaledSize: new google.maps.Size(30, 35) };
const Destino = { url: destino, scaledSize: new google.maps.Size(30, 35) };
const Cliente = { url: cliente, scaledSize: new google.maps.Size(30, 35) };

const DirectionsService = new google.maps.DirectionsService();

class Mapas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      directions: [],
      isOpen: false,
      isOpenC: false,
      isOpenV:false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.empleados !== prevProps.empleados) {
      var datos = [];
      this.props.empleados.forEach(snap => {
        if (snap.viaje === 'activo') {
          firebase.database().ref('Viaje/' + snap.viajeActual).once('value').then(dato => {
            let valor = dato.val();
            if(valor.subirCliente === false){
              DirectionsService.route({
                origin: new google.maps.LatLng(snap.latitud, snap.longitud),
                destination: new google.maps.LatLng(valor.latitudFinal, valor.longuitudFinal),
                waypoints: [{
                  location:  new google.maps.LatLng(valor.latitudInicial, valor.longuitudInicial),
                  stopover: true
                }],
                travelMode: google.maps.TravelMode.DRIVING,
              }
              , (result, status) => {
                if (status === google.maps.DirectionsStatus.OK) {
                  result.request.nombre = snap.nombre; 
                  console.log(result)

                  datos.push(result);
                } else {
                  console.error(`error fetching directions ${result}`);
                }
              })
            }
            else{
              DirectionsService.route({
                origin: new google.maps.LatLng(snap.latitud, snap.longitud),
                destination: new google.maps.LatLng(valor.latitudFinal, valor.longuitudFinal),
                travelMode: google.maps.TravelMode.DRIVING,
              }
              , (result, status) => {
                if (status === google.maps.DirectionsStatus.OK) {
                  result.request.nombre = snap.nombre; 
                  console.log(result)

                  datos.push(result);
                } else {
                  console.error(`error fetching directions ${result}`);
                }
              })
            }
          });
        }
      })
      setTimeout(() => {
        this.setState({ directions: datos })
      }, 1000);
    }
  }

  onToggleOpen = () => {
    this.setState({ isOpen: !this.state.isOpen });
  }
  onToggleOpenC = () => {
    this.setState({ isOpenC: !this.state.isOpenC });
  }

  onToggleOpenV = () => {
    this.setState({ isOpenV: !this.state.isOpenV });
  }

  render() {
    let { directions, isOpen, isOpenC, isOpenV } = this.state;
    return (
      <GoogleMap defaultZoom={14} defaultCenter={{ lat: 13.6988044, lng: -89.2507203 }}>

        {
          this.props.empleados.map((snap, index) => {
            if (snap.tipo_vehiculo === 'Taxi') {
              return (<Marker key={index} position={{ lat: snap.latitud, lng: snap.longitud }} icon={Taxi} onClick={this.onToggleOpenC}> {
                isOpenC &&
                <InfoWindow onCloseClick={this.onToggleOpenC} >
                  <div>
                    {" "}
                    Conductor: {snap.nombre}
                  </div>
                </InfoWindow>
              }</Marker>)
            }
            if (snap.tipo_vehiculo === 'Privado') {
              return (<Marker key={index} position={{ lat: snap.latitud, lng: snap.longitud }} icon={Privado} onClick={this.onToggleOpenC}>
                {
                  isOpenC &&
                  <InfoWindow onCloseClick={this.onToggleOpenC}>
                    <div>
                      {" "}
                      Conductor: {snap.nombre}
                    </div>
                  </InfoWindow>
                }</Marker>)
            }
            if (snap.tipo_vehiculo === 'Microbus') {
              return (<Marker key={index} position={{ lat: snap.latitud, lng: snap.longitud }} icon={Microbus} onClick={this.onToggleOpenC}>
                {
                  isOpenC &&
                  <InfoWindow onCloseClick={this.onToggleOpenC}>
                    <div>
                      {" "}
                      Conductor: {snap.nombre}
                    </div>
                  </InfoWindow>
                }</Marker>)
            }

          })

        }
        {
          directions.map((dato, index) => {
            var leg = dato.request;
              return (
                <div  key={index}>
                  <DirectionsRenderer directions={dato} />
                  <Marker position={leg.destination.location} icon={Destino} onClick={this.onToggleOpen}>
                    {
                      isOpen &&
                      <InfoWindow onCloseClick={this.onToggleOpen}>
                        <div>
                          <FaAnchor />
                          {" "}
                          Destino: Santa Lucia
                    </div>
                      </InfoWindow>
                    }
                  </Marker>
                  {leg.waypoints !== undefined &&
                  <Marker position={leg.waypoints[0].location.location} icon={Cliente} onClick={this.onToggleOpenV}>
                    {
                      isOpenV &&
                      <InfoWindow onCloseClick={this.onToggleOpenV}>
                        <div>
                          {' '}
                         Cliente a la espera del conductor: {leg.nombre}
                        </div>
                      </InfoWindow>
                    }
                  </Marker>
                  }
                </div>
              )
            
          })
        }

      </GoogleMap>
    )
  }
}
export default withGoogleMap(Mapas);




// WEBPACK FOOTER //
// ./src/Components/Mapas/mapa.js